module.exports = __webpack_public_path__ + "img/teppich4.516bb04b.png";